import {
    getWishListsDataView,
    getWishListState,
} from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useWishListState = convertSelectorToHook(getWishListState);
export const useWishListDataView = convertSelectorToHook(getWishListsDataView);
